import { useState, useRef, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import Swal from "sweetalert2";
import {
  useChatHead,
  UseDeleteChatMutation,
  useDeleteMessageMutation,
  useGetMessages,
  useSendMessageMutation,
} from "../../actions/dashboardActions";
export default () => {
  const [chatheadsId, setchatheadsId] = useState(null);
  const [chatheadsName, setchatheadsName] = useState(null);
  const [chatheadsProfileImage, setchatheadsProfileImage] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [selectedMessage, setSelectedMessage] = useState(null);
  const token = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  const messagesEndRef = useRef(null);
  const queryClient = useQueryClient();
  const { data: chatHead } = useChatHead(userId);
  const { data: getMessages = [], isLoading } = useGetMessages(chatheadsId);
  const sendMessageMutation = useSendMessageMutation(
    userId,
    chatheadsId,
    queryClient,
    setNewMessage
  );
  const deleteMessageMutation = useDeleteMessageMutation(
    queryClient,
    chatheadsId,
    setSelectedMessage
  );
  const deleteChatMutation = UseDeleteChatMutation(
    chatheadsId,
    queryClient,
    setchatheadsId,
    setchatheadsName
  );
  const handleDeleteMessage = (messageId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this message!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteMessageMutation.mutate(messageId);
        Swal.fire("Deleted!", "The message has been deleted.", "success");
      }
    });
  };
  const handleDeleteChat = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this chat!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteChatMutation.mutate();
        Swal.fire("Deleted!", "The chat has been deleted.", "success");
      }
    });
  };
  const handleChatHeads = (id, name, profileImage) => {
    setchatheadsId(id);
    setchatheadsName(name);
    setchatheadsProfileImage(profileImage);
  };
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [getMessages]);
  const formatDateHeading = (dateStr) => {
    const today = new Date();
    const date = new Date(dateStr);
    const isToday = date.toDateString() === today.toDateString();

    if (isToday) return "Today";

    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };
  const groupedMessages = getMessages.reduce((acc, msg) => {
    const dateKey = new Date(msg.created_at).toDateString();
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(msg);
    return acc;
  }, {});
  return {
    chatHead,
    chatheadsId,
    chatheadsName,
    newMessage,
    setNewMessage,
    selectedMessage,
    setSelectedMessage,
    messagesEndRef,
    isLoading,
    sendMessageMutation,
    handleDeleteMessage,
    handleDeleteChat,
    handleChatHeads,
    formatDateHeading,
    groupedMessages,
    userId,
    setchatheadsId,
    queryClient,
    chatheadsProfileImage,
  };
};
